import { API_URL } from '../configAndUrls.js'
import { apiRequest, getAuthHeaders, createMutationIdempotencyKey } from '../http.js'

export const campaignsApi = {
getAll: async (clientId = null, options = {}) => {
      const query = clientId ? `?clientId=${clientId}` : ''
      const data = await apiRequest(`/campaigns${query}`, options)
      return data.campaigns || []
    },

    getById: async (id) => {
      const data = await apiRequest(`/campaigns/${id}`)
      return data.campaign
    },

    create: async (campaignData) => {
      const data = await apiRequest('/campaigns', {
        method: 'POST',
        body: JSON.stringify(campaignData),
      })
      return data.campaign
    },

    
    update: async (id, updates) => {
      const data = await apiRequest(`/campaigns/${id}`, {
        method: 'PUT',
        body: JSON.stringify(updates),
      })
      return data.campaign
    },

    
    delete: async (id) => {
      await apiRequest(`/campaigns/${id}`, { method: 'DELETE' })
    },

    
    getPendingRoster: async () => {
      const data = await apiRequest('/campaigns/pending-roster')
      return data.campaigns || []
    },

    
    getProposedInfluencers: async (campaignId, options = {}) => {
      const { withMeta, ...requestOpts } = options
      const data = await apiRequest(`/campaigns/${campaignId}/proposed-influencers`, requestOpts)
      if (withMeta) {
        return {
          proposedInfluencers: data.proposedInfluencers || [],
          generalRosterNote: data.general_roster_note || null,
        }
      }
      return data.proposedInfluencers || []
    },

    
    addProposedInfluencer: async (campaignId, influencerId, options = {}) => {
      const body = { influencer_id: influencerId }
      if (options.rate !== undefined && options.rate !== null && options.rate !== '') body.rate = options.rate
      const data = await apiRequest(`/campaigns/${campaignId}/proposed-influencers`, {
        method: 'POST',
        body: JSON.stringify(body),
      })
      return data.proposedInfluencer
    },

    
    updateProposedInfluencer: async (campaignId, proposedId, body) => {
      const data = await apiRequest(`/campaigns/${campaignId}/proposed-influencers/${proposedId}`, {
        method: 'PATCH',
        body: JSON.stringify(body),
      })
      return data.proposedInfluencer
    },

    
    removeProposedInfluencer: async (campaignId, proposedId) => {
      await apiRequest(`/campaigns/${campaignId}/proposed-influencers/${proposedId}`, {
        method: 'DELETE',
      })
    },

    
    approveRoster: async (campaignId, body) => {
      const data = await apiRequest(`/campaigns/${campaignId}/approve-roster`, {
        method: 'POST',
        body: JSON.stringify(body),
        idempotencyKey: createMutationIdempotencyKey('approve-roster'),
      })
      return { proposedInfluencers: data.proposedInfluencers || [] }
    },

    
    getRosterVersions: async (campaignId) => {
      const data = await apiRequest(`/campaigns/${campaignId}/roster-versions`)
      return data.versions || []
    },

    
    sendRosterToClient: async (campaignId) => {
      return apiRequest(`/campaigns/${campaignId}/send-roster-to-client`, {
        method: 'POST',
        idempotencyKey: createMutationIdempotencyKey('send-roster'),
      })
    },

    
    getInviteReadiness: async (campaignId, options = {}) => {
      return apiRequest(`/campaigns/${campaignId}/invite-readiness`, options)
    },

    getBriefPresignedUpload: async (id, filename, contentType) => {
      const params = new URLSearchParams({ filename })
      if (contentType) params.set('contentType', contentType)
      const response = await fetch(`${API_URL}/campaigns/${id}/brief/presigned-upload?${params}`, {
        headers: getAuthHeaders(),
      })
      const data = await response.json().catch(() => ({}))
      if (response.status === 503 && data.error === 'S3_NOT_CONFIGURED') return null
      if (!response.ok) throw new Error(data.error || data.message || 'Failed to get campaign brief upload URL')
      return data
    },
    patchBrief: async (id, body) => {
      const data = await apiRequest(`/campaigns/${id}/brief`, {
        method: 'PATCH',
        body: JSON.stringify(body),
      })
      return data.campaign
    },
    getBriefDownloadUrl: async (id) => {
      return apiRequest(`/campaigns/${id}/brief/download-url`)
    },
    applyDefaultSlots: async (campaignId, body = {}, options = {}) => {
      return apiRequest(`/campaigns/${campaignId}/apply-default-slots`, {
        method: 'POST',
        body,
        idempotencyKey: createMutationIdempotencyKey('apply-default-slots'),
        ...options,
      })
    },

    inviteApprovedRoster: async (campaignId) => {
      return apiRequest(`/campaigns/${campaignId}/invite-approved`, {
        method: 'POST',
        idempotencyKey: createMutationIdempotencyKey('invite-approved'),
      })
    },

    
    launchCampaign: async (campaignId) => {
      return apiRequest(`/campaigns/${campaignId}/launch`, {
        method: 'POST',
        idempotencyKey: createMutationIdempotencyKey('launch-campaign'),
      })
    },
}
